(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-detail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('article-toc')) {
    class ArticleToc extends HTMLElement {
      connectedCallback() {
        const prose = document.querySelector('[data-article-prose]');
        const list = this.querySelector('ol');
        if (!prose || !list) return;

        const headings = [...prose.querySelectorAll('h2')].filter((h) => h.textContent.trim());
        if (headings.length < 2) return;

        const used = new Set();
        const links = headings.map((heading) => {
          if (!heading.id) {
            const base =
              heading.textContent
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-|-$/g, '') || 'section';
            let id = base;
            let n = 2;
            while (used.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
            heading.id = id;
          }
          used.add(heading.id);

          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
          return link;
        });

        this.hidden = false;

        const setCurrent = (index) => {
          links.forEach((link, i) => {
            if (i === index) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };
        setCurrent(0);

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) setCurrent(headings.indexOf(entry.target));
            });
          },
          { rootMargin: '0px 0px -70% 0px' }
        );
        headings.forEach((heading) => this.observer.observe(heading));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('article-toc', ArticleToc);
  }

  if (!window.articleCopyBound) {
    window.articleCopyBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-article-copy]');
      if (!button) return;
      const status = button.closest('.article-detail__share')?.querySelector('.article-detail__share-status');
      try {
        await navigator.clipboard.writeText(button.dataset.articleCopy);
        if (status) status.textContent = status.dataset.copiedLabel;
      } catch (error) {
        if (status) status.textContent = button.dataset.articleCopy;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
